import { VendorsearchService } from './../../services/vendor/vendorsearch.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NgForm } from '@angular/forms';
import { ManageUsersService } from '../../services/manage-users/manage-users.service';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { empty } from 'rxjs/observable/empty';

@Component({
  selector: 'app-manage-users-dialog',
  templateUrl: './manage-users-dialog.component.html',
  styleUrls: ['./manage-users-dialog.component.css']
})
export class ManageUsersDialogComponent implements OnInit {
  isVendorDetailsDisabled:boolean = false;
  isEmailHidden:boolean = true;
  isVendorHidden:boolean = false;
  isDisabled: boolean = true;
  DocListErr: boolean;
  DocListErrMsg: string;
  message: string;
  docId: any;
  QACRoleToVendor: any;
  SiteAdmindocId: any;
  DocTypeErrMsg;
  DocTypeErr: boolean = false;
  roles: any;
  activeFlag: boolean = false;
  myControl = new FormControl();
  status: any;
  error: string;
  output: any;
  vendorCheck: string;
  matchStatus= true;
  vendorname = [];
  data: any = {
    docId: '',
    vendor_name: '',
    master_vendor_id: 0,
    master_vendor_name: '',
    first_name: '',
    last_name: '',
    middle_name: '',
    email_id: '',
    role: '',
    isActive: '',
    created_by: '',
    updated_by: '',
    blocked_user: '',
  };

  constructor(private vendorService: VendorsearchService,
              public dialogRef: MatDialogRef<ManageUsersDialogComponent>,
              private manageUsersService: ManageUsersService,
              @Inject(MAT_DIALOG_DATA) public siteAdminData: any) { }

  ngOnInit() {
    this.getRoles();
    this.isVendorDetailsDisabled = false;
    if (this.siteAdminData.status === 'update') {
      this.isVendorDetailsDisabled = true;
      if (this.siteAdminData.data.Role === 'Recovery Vendor') {
         this.isEmailHidden = false;
      } else {
        this.isEmailHidden = true;
      }
      this.isDisabled = false;
      this.activeFlag = true;

      this.SiteAdmindocId = this.siteAdminData.data._id;
      this.editSiteAdminData(this.siteAdminData.data);
    }
  }

  selectedVendor(value) {
    const data = this.vendorname.find(x => x.MasterVendorName.toLowerCase() === value.toLowerCase());
    this.data.email_id = data.Email;
    this.data.master_vendor_id = data.MasterVendorId;
    this.data.master_vendor_name = data.MasterVendorName;
  }

  search(value) {
    if (value != null && value != undefined) {
      if (value.length >= 3) {
        let searchby = value;
        this.vendorService.getVendorEmail(searchby).subscribe(
          (users: any) => {
            
            this.vendorname = users.VendorInfo;
            this.matchStatus= true;
            users = null;
          }, err => {
            this.matchStatus= false;
            this.vendorname= [];
            this.data.email_id = '';
           }
        );
      }
      else {
        this.data.email_id = null;
      }
    }
  }

  getRoles() {
    this.manageUsersService.getRoles().subscribe(res => {
      this.roles = res.Roles;
      // this.QACRoleToVendor = JSON.parse(
      //   JSON.stringify(res, function (key, value) {
      //     return value.Roles[1].Code === 1 ? value.Roles[1].Role = 'PAR Vendor Relations' : value;
      //   })
      // );
      // JSON.parse(
      //   JSON.stringify(res, function (key, value) {
      //     return value.Roles[2].Code === 2 ? value.Roles[2].Role = 'PAR Manager' : value;
      //   })
      // );
      // JSON.parse(
      //   JSON.stringify(res, function (key, value) {
      //     return value.Roles[3].Code === 4 ? value.Roles[3].Role = 'PAR Admin' : value;
      //   })
      // );
      // JSON.parse(
      //   JSON.stringify(res, function (key, value) {
      //     return value.Roles[0].Code === 16 ? value.Roles[0].Role = 'Site Admin' : value;
      //   })
      // );
      // JSON.parse(
      //   JSON.stringify(res, function (key, value) {
      
      //     return value.Roles[5].Code === 32 ? value.Roles[5].Role = 'Recovery Vendor' : value;
      //   })
      // );
      // JSON.parse(
      //   JSON.stringify(res, function (key, value) {
      
      //     return value.Roles[7].Code === 128 ? value.Roles[7].Role = 'Resolution Manager' : value;
      //   })
      // );
      for(let x =0; x<this.roles.length; x++) {
        if (this.roles[x].Code === 1) {
          this.roles[x].Role = 'PAR Vendor Relations';
        } else if (this.roles[x].Code === 2) {
          this.roles[x].Role = 'PAR Manager';
        } else if (this.roles[x].Code === 4) {
          this.roles[x].Role = 'PAR Admin';
        } else if (this.roles[x].Code === 16) {
          this.roles[x].Role = 'Site Admin';
        } else if (this.roles[x].Code === 32) {
          this.roles[x].Role = 'Recovery Vendor';
        } else if (this.roles[x].Code === 128) {
          this.roles[x].Role = 'Resolution Manager';
        }
    }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  editSiteAdminData(siteAdminData) {
    this.data.role = siteAdminData.Role;
    this.data.vendorname = siteAdminData.MasterVendorName;
    this.data.first_name = siteAdminData.FirstName;
    this.data.last_name = siteAdminData.LastName;
    this.data.middle_name = siteAdminData.MiddleName;
    this.data.email_id = siteAdminData.Email;
    this.data.blocked_user = siteAdminData.BlockedUser;
    this.data.vendor_name = siteAdminData.MasterVendorName;
    this.data.docId = siteAdminData._id;
    if (this.data.blocked_user === 'N') {
      this.data.blocked_user = false;
    }
    if (siteAdminData.Role === 'QAC') {
      this.data.role = 'PAR Vendor Relations';
    } else if (siteAdminData.Role === 'PARManager') {
      this.data.role = 'PAR Manager';
    } else if (siteAdminData.Role === 'PARAdmin') {
      this.data.role = 'PAR Admin';
    } else if (siteAdminData.Role === 'SiteAdmin') {
      this.data.role = 'Site Admin';
    } else if (siteAdminData.Role === 'Vendor') {
      this.data.role = 'Recovery Vendor';
      this.isEmailHidden = false;
    } else if(siteAdminData.Role === 'Recovery Vendor'){
      this.data.role = 'Recovery Vendor';
      this.isVendorHidden = true;
      this.isEmailHidden = false;
    } else if (siteAdminData.Role === 'ResolutionManager') {
      this.data.role = 'Resolution Manager';
    } else {
      this.data.role = siteAdminData.Role;
      // this.isVendorHidden = false;
    }
  }

  selectedRole(event) {
    this.isDisabled = false;
    if (event.value) {
      if (event.value == 'Recovery Vendor') {
        this.isVendorHidden = true;
        this.isEmailHidden = false;
        this.status = 'Vendor';
      } else {
        this.status = 'other';
        this.isVendorHidden = false;
        this.isEmailHidden = true;
      }
    }
  }

  onChange(event) {
    if (event) {
      this.data.email_id = null;
    } else {
      this.selectedVendor(event);
    }
  }

  onFormSubmit(form: NgForm) {
    const datalocal = form.value;
    if (datalocal.role === 'PAR Vendor Relations') {
      datalocal.role = 'QAC';
    }
    if (datalocal.role === 'PAR Manager') {
      datalocal.role = 'PARManager';
    }
    if (datalocal.role === 'PAR Admin') {
      datalocal.role = 'PARAdmin';
    }
    if (datalocal.role === 'Site Admin') {
      datalocal.role = 'SiteAdmin';
    }
    if (datalocal.role === 'Recovery Vendor') {
      datalocal.role = 'Vendor';
    }
    if (datalocal.role === 'Resolution Manager') {
      datalocal.role = 'ResolutionManager';
    }
    datalocal.docId = this.SiteAdmindocId;
    if (!datalocal.docId) {
      datalocal.created_by = localStorage.getItem('loginID');
      datalocal.MasterVendorId = this.data.master_vendor_id;
      let vName;
      if (this.vendorname) {
        vName = this.vendorname.find(value =>  this.data.vendor_name === datalocal.vendor_name);
      }

      if (datalocal.role === 'Vendor') {
        if (vName) {
          //APi call here
          datalocal.MasterVendorName = this.data.master_vendor_name;
          this.manageUsersService.addSiteAdmin(datalocal).subscribe(res => {
           
            this.manageUsersService.load.next('success');
            this.onNoClick();
          }, err => {
            if (err === 'Bad Request') {
              this.message = 'The user already exists with that email address.';
            } else {
              this.message = err;
              this.DocListErrMsg = 'Site Admin Updation' + err;
              this.DocListErr = true;
            }
          });
        } else {
          this.message = 'Vendor name is not valid';
        }
      } else {
        this.manageUsersService.addSiteAdmin(datalocal).subscribe(res => {
          
          this.manageUsersService.load.next('success');
          this.onNoClick();
        }, err => {
          if (err === 'Bad Request') {
            this.message = 'The user already exists with that email address.';
          } else {
            this.message = err;
            this.DocListErrMsg = 'Site Admin Updation' + err;
            this.DocListErr = true;
          }
        });
      }
    } else {
      if (datalocal.blocked_user === true) {
        datalocal.blocked_user = 'Y';
      } else {
        datalocal.blocked_user = 'N';
      }
      this.manageUsersService.editSiteAdmin(datalocal).subscribe(res => {
        this.manageUsersService.load.next('success');
        this.onNoClick();
      }, err => {
        this.message = err;
        this.DocListErrMsg = 'Site Admin Updation' + err;
        this.DocListErr = true;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/manage-users-dialog/manage-users-dialog.component.ts